import EventEmitter from 'common/EventEmitter'
import { Events, EventNotAllowedProps } from './Enums'

class ParentNotifier {
    constructor() {
        this.targetOrigin = '*'
        this.notify = this.notify.bind(this)
        return (ParentNotifier.instance = ParentNotifier.instance || this)
    }

    init() {
        for (const event in Events) {
            EventEmitter.on(Events[event], (payload) => this.onEvent(event, payload))
        }
    }

    onEvent(event, payload) {
        const eventNotAllowed = EventNotAllowedProps[event] || []
        const globalNotAllowed = EventNotAllowedProps.Global || []
        const notAllowed = globalNotAllowed.concat(eventNotAllowed)
        const filteredData = this.deleteNotAllowed({ ...payload }, notAllowed)
        this.notify(Events[event], filteredData)
    }

    notify(event, payload) {
        window.parent.postMessage({ event, payload }, this.targetOrigin)
    }

    deleteNotAllowed(data, props) {
        props.map((prop) => data[prop] && delete data[prop])
        return data
    }
}

export default new ParentNotifier()
